/* eslint-disable react/no-unknown-property */
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { Checks } from '../../models/setting'
import { replaceAccessToken } from '../login/loglinSlice'
import { selectSettings } from '../user/setting/settingSlice'
import styles from "./shoper.module.css";
import {selectChainName, selectTenantName, selectZcShoperId} from "../../app/applicationSlice";

export const Shoper = () => {
  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const [zcPic, setZcPic] = useState("");

  const [iframeUrl, setIframeUrl] = useState('')

  const zcShoperId = useSelector(selectZcShoperId)

  const settingLKSC = useSelector(selectSettings)?.[Checks.LKSC]

  useEffect(() => {
    if (settingLKSC == 2) {
      setZcPic("https://hydhis-public.oss-cn-hangzhou.aliyuncs.com/zcShoper.png")
    } else {
      dispatch(replaceAccessToken())
        .then(unwrapResult)
        .then((res) => {
          const url = window.location.host
          if (res.token) {
            // 有权限
            if (url.indexOf('hydhis.cn') >= 0) {
              // 正式
              setIframeUrl(
                `https://${
                  res.type || 'fs'
                }.store.mall.linkang-medical.com/?accessToken=${res.token}`
              )
            } else if (url === 'his.test.hydhis.com') {
              // 测试
              setIframeUrl(
                `http://${
                  res.type || 'fs'
                }.store.mall.test.hydhis.com/?accessToken=${res.token}`
              )
            } else if (url === `his.develop.hydhis.com`) {
              // 开发
              setIframeUrl(
                `http://${
                  res.type || 'fs'
                }.store.mall.develop.hydhis.com/?accessToken=${res.token}`
              )
            } else {
              // 其他端口
              // setIframeUrl(
              //   `http://${
              //     res.type || 'fs'
              //   }.store.mall.develop.hydhis.com/?accessToken=${res.token}`
              // )
            }
          } else {
            // 无权限
            if (url.indexOf('hydhis.cn') >= 0) {
              // 正式
              setIframeUrl(
                `https://${res.type || 'fs'}.store.mall.linkang-medical.com/`
              )
            } else if (url === 'his.test.hydhis.com') {
              // 测试
              setIframeUrl(
                `http://${res.type || 'fs'}.store.mall.test.hydhis.com/`
              )
            } else if (url === `his.develop.hydhis.com`) {
              // 开发
              setIframeUrl(
                `http://${res.type || 'fs'}.store.mall.develop.hydhis.com/`
              )
            } else {
              // 其他端口
              // setIframeUrl(
              //   `http://${res.type || 'fs'}.store.mall.develop.hydhis.com/`
              // )
            }
          }
        })
    }
  }, [settingLKSC])
  return (
    <div style={{ padding: '20px', height: '100%' }}>
      {settingLKSC == 2 ?<div className={styles.tips} data-umami-event='珍诚商城'
                              data-umami-event-tenantName={tenantName} onClick={()=>{
        const w = window.open(
          'http://www.zc511.com/partner/pharma-procurement.shtml?code='+zcShoperId+'&secret=6LylpTWPQWtr12kCkryfIM3jRAeV9NefPUM0YEKq2ME='
        )

      }}>
        <img src={zcPic}></img>
        <div>
          <p style={{fontWeight:700,color:"#2a43a1",marginTop:10}}>浙江珍诚医药在线股份有限公司 / 完成签约 全场95折起 / 支持一键采购入库 / 无缝对接GSP</p>
        </div>

      </div>:<iframe
        src={iframeUrl}
        style={{ width: '100%', height: '100%' }}
        scrolling='auto'
        frameBorder='0'
      ></iframe>}

    </div>
  )
}
